<template>
  <div class="comment">
    <div class="avatar">
      <div class="avatar-box">
        <img v-if="item.img_url != null" :src="item.img_url" alt="" />
        <img v-else-if="item.img_url == null" src="@img/user_default.png" alt="" />
        <!-- <img :src="item.img_url ? item.img_url : '@img/user_default.png'" alt> -->
      </div>
    </div>
    <div class="right">
      <div class="top">
        <div class="name">{{item.user_name}}</div>
        <div class="create-time">{{item.create_time | dateformat('YYYY-MM-DD HH:mm:ss')}}</div>
      </div>
      <div class="bottom">
        <div class="add">
          <div class="text">{{item.content}}</div>
          <!-- <div class="submit">
            <img src="@img/comment2.png" alt>
            {{item.replies ? item.replies.length : '0' }}    
          </div> -->
        </div>
        <div class="item-box" v-if="item.replies && item.replies.length > 0">
          <div class="item" v-for="(ix,index) in item.replies" :key="index">
            <div v-if="ix.visible == 1">
              <span class="username" @click="reply(item.id,ix.course_id,ix.user_name)">{{ix.user_name}}</span>
              回复  <span class="username" v-if="ix.target_name">{{ix.target_name}}：</span>
              <span class="userreply">{{ix.content}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ques",
  props: ["item"],
  methods: {
    submitComment(root_id, replyTitle) {
      console.log(root_id);
      this.$parent.show(root_id, 0, replyTitle);
    },
    reply(comment_id, course_id, replyTitle) {
      this.$parent.showReply(comment_id, course_id, replyTitle);
    }
  }
};
</script>
<style lang="less" scoped>
.comment {
  display: flex;
  min-height: 70px;
  margin-bottom: 30px;
  .avatar {
    flex: 1;
    display: flex;
    margin-right: 20px;
    .avatar-box {
      border-radius: 50%;
      width: 70.45px;
      height: 70.45px;
      overflow: hidden;
      position: relative;
      img {
        position: absolute;
        width: 100%;
        height: 70.45px;
        left: 0;
        top: 50%;
        -webkit-transform: translate3d(0, -50%, 0);
        -moz-transform: translate3d(0, -50%, 0);
        -o-transform: translate3d(0, -50%, 0);
        -ms-transform: translate3d(0, -50%, 0);
        transform: translate3d(0, -50%, 0);
      }
    }
  }
  .right {
    flex: 10;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .top {
      display: flex;
      justify-content: space-between;
      padding-bottom: 10px;
    }
    .bottom {
      display: flex;
      flex-direction: column;
      .add {
        display: flex;
        justify-content: space-between;
        .submit {
          color: #3b9dff;
          cursor: pointer;
          img {
            width: 28px;
            height: 28px;
            margin-right: 2px;
            vertical-align: middle;
          }
        }
        .text {
          word-break: break-all;
          width:90%;
        }
      }
      .item-box {
        width: 100%;
        .item {
          padding: 5px;
          background: #f5f5f5;
          font-size: 14px;
          word-break: break-all;
          .username {
            cursor: pointer;
            color: #08030c;
          }
          .userreply {
            color: #08030c
          }
        }
      }
    }
  }
}
</style>
